var ButtonVariant = /*#__PURE__*/function (ButtonVariant) {
  ButtonVariant["ELEVATED"] = "elevated";
  ButtonVariant["PRIMARY"] = "primary";
  ButtonVariant["SECONDARY"] = "secondary";
  ButtonVariant["TERTIARY"] = "tertiary";
  ButtonVariant["LINK"] = "link";
  ButtonVariant["PLAIN"] = "plain";
  ButtonVariant["NEUTRAL"] = "neutral";
  ButtonVariant["OUTLINE"] = "outline";
  ButtonVariant["SOLID"] = "solid";
  ButtonVariant["GHOST"] = "ghost";
  ButtonVariant["DESTRUCTIVE"] = "destructive";
  return ButtonVariant;
}({});
var ButtonSize = /*#__PURE__*/function (ButtonSize) {
  ButtonSize["COMPACT"] = "compact";
  ButtonSize["2XS"] = "2xs";
  ButtonSize["XS"] = "xs";
  ButtonSize["SM"] = "sm";
  ButtonSize["MD"] = "md";
  ButtonSize["LG"] = "lg";
  return ButtonSize;
}({});
export { ButtonSize, ButtonVariant };